import { connect } from 'react-redux';
import { FormattedDate } from 'react-intl';
import classNames from 'classnames';

import { getLogoFromProvider } from '../../../../tradingData/linkedAccounts/LinkedAccountsHelpers';
import {
    getLatestOnlineAccountExpiryDate,
    getLatestOnlineAccountProvider,
    getBankNameFromLatestOnlineAccount,
    isLatestOnlineAccountNotActive,
    getLatestOnlineAccountStatus,
    OPEN_BANKING_STATUS
} from '../../../../../api/lendingAPI/OnlineAccountsSelectors';
import { getCompanyName } from '../../../../../api/lendingAPI/CustomerStateAPISelector';
import { calculateRelinkDateFromExpiry } from './OpenBankingLink';
import { ErrorStatusOutlineSVG } from '../../../../../svgComponents/errorStatusOutlineSVG/ErrorStatusOutline';
import styles from './RelinkBankingModal.module.css';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';

const mapStateToProps = (state) => {
    return {
        expires_at: getLatestOnlineAccountExpiryDate(state),
        provider: getLatestOnlineAccountProvider(state),
        bankName: getBankNameFromLatestOnlineAccount(state),
        companyName: getCompanyName(state),
        isOpenBankingNotActive: isLatestOnlineAccountNotActive(state),
        status: getLatestOnlineAccountStatus(state)
    };
};

const RelinkBankingModal = ({
    expires_at,
    provider,
    bankName,
    companyName,
    isOpenBankingNotActive,
    status
}) => {
    const daysUntilRelink = calculateRelinkDateFromExpiry(expires_at);
    const shouldRelinkOpenBanking = isOpenBankingNotActive;
    const ProviderLogo = getLogoFromProvider(provider);
    return (
        <div
            className={styles.container}
            data-testid="relink-open-banking-modal"
        >
            <h1 className={styles.heading}>Relink your banking account</h1>
            <div className={styles.flexColumn}>
                <div
                    className={classNames(
                        styles.flexRow,
                        styles.linkedProvider
                    )}
                >
                    <div className={styles.linkedProviderIcon}>
                        <ProviderLogo />
                    </div>
                    <div className={styles.flexColumn}>
                        <div className={styles.title} data-testid="bankName">
                            {bankName}
                        </div>
                        <div data-testid="companyName">
                            <strong>{companyName}</strong>
                        </div>
                    </div>
                </div>
                <div
                    className={classNames(styles.flexRow, styles.spaceBetween)}
                >
                    <div>
                        <div className={styles.title}>Status</div>
                        <div data-testid="expiredText">
                            {shouldRelinkOpenBanking ? (
                                <strong className={styles.redText}>
                                    {status === OPEN_BANKING_STATUS.EXPIRED
                                        ? 'Expired'
                                        : 'Unlinked'}
                                </strong>
                            ) : (
                                <strong>
                                    Linked for {daysUntilRelink} days
                                </strong>
                            )}
                        </div>
                    </div>
                    <div>
                        <div className={styles.title}>Expiration date</div>
                        <div data-testid="expirationDate">
                            <strong
                                className={
                                    shouldRelinkOpenBanking
                                        ? styles.redText
                                        : ''
                                }
                            >
                                <FormattedDate
                                    day="numeric"
                                    month="short"
                                    year="numeric"
                                    value={new Date(expires_at)}
                                />
                            </strong>
                        </div>
                    </div>
                </div>
            </div>

            <NEW_IwLinkButton
                variant="primary"
                data-testid="relinkModalButton"
                className={styles.button}
                to={{
                    pathname: '/trading/'
                }}
            >
                {shouldRelinkOpenBanking
                    ? 'Relink your account'
                    : 'Get me back to 90 days'}
            </NEW_IwLinkButton>

            <div className={styles.footer}>
                <div className={styles.icon}>
                    <ErrorStatusOutlineSVG />
                </div>
                <div>
                    {shouldRelinkOpenBanking ? (
                        <p>
                            If you don't link up, you'll be in breach of the
                            loan agreement. We'll also have to make assumptions
                            about your next repayment amount, which could lead
                            to higher charges.
                        </p>
                    ) : (
                        <p>
                            Open Banking links expire every 90 days, so you
                            might need to do this again.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RelinkBankingModal);
